import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
    makeStyles,
    useTheme
} from '@material-ui/core';

const styles = makeStyles(theme => ({
    listContainer: {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
        borderRadius: '10px',
        display: 'flex',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
    },
    listItem: {
        padding: '12px 24px',
        cursor: 'pointer',
        borderRight: '1px solid #ccc',
        fontWeight: 500,
        '&:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },
        '&:last-child': {
            borderRight: 'none',
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },
        '&:hover': {
            backgroundColor: theme.palette.primary.grey,
        },
    },
    active: {
        backgroundColor: theme.palette.primary.grey,
    },
    icon: {
        marginRight: 5,
    }
}));

function CategoriesFilter(props) {
    const [selected, setSelected] = useState('');
    let classes = styles(),
        theme = useTheme(),
        { options, changeHandler } = props;

    // debugger
    useEffect(() => {
        const selectedOptions = options.filter(option => option.selected);
        if (selectedOptions.length === 1) {
            setSelected(selectedOptions[0].name);
        } else if (selectedOptions.length > 1) {
            setSelected('See All');
        }
    }, [options]);


    return (
        <>
            <ul className={classes.listContainer}>
                <li
                    className={`${classes.listItem} ${selected === 'See All' ? classes.active : ''
                        }`}
                    onClick={() => changeHandler(null, 'category')}
                >
                    See All
                </li>
                <li
                    className={`${classes.listItem} ${selected === 'Alerts' ? classes.active : ''
                        }`}
                    onClick={() => changeHandler(options[0], 'category')}
                >
                    <FontAwesomeIcon icon={["fas", "bell"]} className={classes.icon} /> Alerts
                </li>
                <li
                    className={`${classes.listItem} ${selected === 'Discussions' ? classes.active : ''
                        }`}
                    onClick={() => changeHandler(options[1], 'category')}
                >
                    <FontAwesomeIcon icon={["fas", "comments-alt"]} className={classes.icon} /> Discussions
                </li>
            </ul>
        </>
    );
}

CategoriesFilter.propTypes = {
    changeHandler: PropTypes.func,
};

export default CategoriesFilter;